// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setting-item-container {
    line-height: 1.5;
    margin-left: 0.4rem;
    margin-right: 0.4rem;
}

.setting-body__line {
    height: 7.2rem;
    display: flex;
}

.setting-header__close-button-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
}

.setting-header__close-button-wrapper button {
    margin-right: 1.8rem;
}

.setting-body__setting-id-wrapper {
    display: block;
    width: 80%;
    max-width: 100rem;
    float: left;
}

.setting-body__setting-type-wrapper { 
    display: block; 
    float: right;
}

.setting-body__setting-type {
    display: block;
    width: auto;
}

.setting-body__key-value-pairs-list-wrapper {
    max-height: 36rem;
    overflow-y: auto;
}

.setting-body__add-button-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 1.8rem;
}

.setting-body__key-wrapper {
    float: left;
    width: 35%;
    margin-right: 1.8rem;
}

.setting-body__value-wrapper {
    float: left;
    width: 50%;
    margin-right: 1.8rem;
}

.setting-body__value{
    resize: none;
    height: 5.4rem;
}

.setting-body__delete-key-value-wrapper {
    padding-top: .8rem;
    margin-right: 1.8rem;
    height: 100%;
    float: right;
}

.setting-body__delete-key-value {
    background-color: #d22e35;
}

.setting-item-modal.modal-dialog {
    max-width: 65%;
    min-width: 65%;
    overflow: hidden;
}

.setting-item-modal .modal-title {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    font-size: 3.6rem;
}

.setting-footer-wrapper {
    margin-right: 5.4rem;
}

.setting-body__textarea {
    height: 450px;
}`, "",{"version":3,"sources":["webpack://./src/app/setting/settings-main/settings-list/setting-item/SettingItem.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".setting-item-container {\r\n    line-height: 1.5;\r\n    margin-left: 0.4rem;\r\n    margin-right: 0.4rem;\r\n}\r\n\r\n.setting-body__line {\r\n    height: 7.2rem;\r\n    display: flex;\r\n}\r\n\r\n.setting-header__close-button-wrapper {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-wrap: nowrap;\r\n}\r\n\r\n.setting-header__close-button-wrapper button {\r\n    margin-right: 1.8rem;\r\n}\r\n\r\n.setting-body__setting-id-wrapper {\r\n    display: block;\r\n    width: 80%;\r\n    max-width: 100rem;\r\n    float: left;\r\n}\r\n\r\n.setting-body__setting-type-wrapper { \r\n    display: block; \r\n    float: right;\r\n}\r\n\r\n.setting-body__setting-type {\r\n    display: block;\r\n    width: auto;\r\n}\r\n\r\n.setting-body__key-value-pairs-list-wrapper {\r\n    max-height: 36rem;\r\n    overflow-y: auto;\r\n}\r\n\r\n.setting-body__add-button-wrapper {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-top: 1.8rem;\r\n}\r\n\r\n.setting-body__key-wrapper {\r\n    float: left;\r\n    width: 35%;\r\n    margin-right: 1.8rem;\r\n}\r\n\r\n.setting-body__value-wrapper {\r\n    float: left;\r\n    width: 50%;\r\n    margin-right: 1.8rem;\r\n}\r\n\r\n.setting-body__value{\r\n    resize: none;\r\n    height: 5.4rem;\r\n}\r\n\r\n.setting-body__delete-key-value-wrapper {\r\n    padding-top: .8rem;\r\n    margin-right: 1.8rem;\r\n    height: 100%;\r\n    float: right;\r\n}\r\n\r\n.setting-body__delete-key-value {\r\n    background-color: #d22e35;\r\n}\r\n\r\n.setting-item-modal.modal-dialog {\r\n    max-width: 65%;\r\n    min-width: 65%;\r\n    overflow: hidden;\r\n}\r\n\r\n.setting-item-modal .modal-title {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    font-weight: bold;\r\n    font-size: 3.6rem;\r\n}\r\n\r\n.setting-footer-wrapper {\r\n    margin-right: 5.4rem;\r\n}\r\n\r\n.setting-body__textarea {\r\n    height: 450px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
